export default {
  title: "Warrior",
  content: [
    "Warriors now retain up to 10 rage points when you change stances.",
    "Thunder Clap can now be used in defensive stance.",
    "Slam can now be cast while moving and ignores pushback caused by damage.",
    "Increased the damage dealt by Rend.",
    "Increased the time required for your rage to decay while out of combat 30%.",
  ],
};
